import { render } from "./identity.vue?vue&type=template&id=17c7bb50"
import script from "./identity.vue?vue&type=script&lang=js"
export * from "./identity.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__